import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

export interface UIState {
    isCollapsible?: boolean;
    isCollapsed?: boolean;
}

const initialState: UIState = {
    isCollapsible: false,
    isCollapsed: false,
};

@Injectable()
export class UiStateService {
    private _state$: BehaviorSubject<UIState> = new BehaviorSubject(initialState);

    constructor() {
    }

    // -------------------
    // exposed observables
    // -------------------
    get state$(): Observable<UIState> {
        return this._state$.asObservable();
    }

    // ----------------
    // state operations
    // ----------------
    get state(): UIState {
        return this._state$.getValue();
    }

    // -----------------
    // getters & setters
    // -----------------
    setState(nextState: UIState) {
        this._state$.next({
            ...this.state,
            ...nextState,
        });
    }

    set isCollapsed( isActive: boolean ) {
        this.setState({
            ...this.state,
            isCollapsed: isActive,
        });
    }

    set isCollapsible( isActive: boolean ) {
        this.setState({
            ...this.state,
            isCollapsible: isActive,
        });
    }

    // STATE TOGGLERS
    toggleCollapsed() {
        this.isCollapsed = !this.state.isCollapsed;
    }
}
